'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Available to all components


var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require('core-js/modules/es6.object.assign');

/**
 * Internal class for instantiating the Module Manager
 */

var ComponentManager = function () {

  /**
   * Start the component manager
   *
   * @param {string} manifest - arbitrary string corresponding to an object on `window` that we'll use to track configuration and instances of each component.
   *                            This generally corresponds to the WP theme name (`wp-starter-theme` for example)
   */
  function ComponentManager(manifest) {
    _classCallCheck(this, ComponentManager);

    var manifestDefaults = { components: {} };

    window[manifest] = window[manifest] ? Object.assign({}, window[manifest], manifestDefaults) : manifestDefaults;

    this.manifest = window[manifest];
  }

  /**
   * Loop through component elements and instantiate the component for each
   *
   * @param {object|array} configs - config or configs corresponding to components you want to instance
   * @param {HTMLElement} context - context on which to initalize components, default is `document`
   */


  _createClass(ComponentManager, [{
    key: 'initComponents',
    value: function initComponents(configs) {
      var _this = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

      var componentConfigs = Array.isArray(configs) ? configs : [configs];

      componentConfigs.forEach(function (config) {
        var componentConfig = config;
        var componentName = componentConfig.name;
        var ComponentClass = componentConfig.class;

        // Check if component is configured and extends the core Component class
        if (ComponentClass.prototype instanceof _Component2.default) {
          var hasComponent = Object.prototype.hasOwnProperty.call(_this.manifest.components, componentName);
          var componentEls = context.querySelectorAll('[data-component=\'' + componentConfig.name + '\']');

          // Can't find any elements!
          if (!componentEls.length) {
            /* eslint-disable no-console, max-len */
            console.info('Component \'' + componentName + '\' does not exist or is configured incorrectly.\nCheck this component\'s config to ensure this component has a configuration object.\nAlso, verify the \'' + componentName + '\' class extends the core component class located in client/js/site/Component.js');
            /* eslint-enable */
            return;
          }

          // Add component to manifest if it doesn't exist already
          if (!hasComponent) {
            _this.manifest.components[componentName] = {
              config: componentConfig,
              instances: []
            };
          }

          // Loop through elements and add instance for each
          Array.prototype.forEach.call(componentEls, function (element) {
            // Skip this element if we've already instantiated a component on it
            var exists = _this.manifest.components[componentName].instances.some(function (instance) {
              return element === instance.element;
            });

            if (exists) {
              return;
            }

            // Create and start instance
            componentConfig.element = element;
            var instance = new ComponentClass(componentConfig);

            // add instance to manifest
            _this.manifest.components[componentName].instances.push({
              instance: instance,
              element: element
            });
          });
        }
      });
    }

    /**
     * Loop through and restart components (use, for example, if you've removed and re-added components from the DOM and need the JS started again)
     *
     * @param {string} componentName - name of component to instantiate
     * @param {HTMLElement} context - context on which to initalize components, default is entire document
     */

  }, {
    key: 'reinitComponent',
    value: function reinitComponent(componentName, context) {
      var componentConfig = this.manifest.components[componentName].config;

      if (componentConfig) {
        this.initComponents([componentConfig], context);
      }
    }

    /**
     * Call a method of a component from a different component
     *
     * @param {string} componentName - Name of component that has target function
     * @param {function} method - Component method you want to call
     * @param {array} args - Array of arguments to pass to component method
     */

  }], [{
    key: 'callComponentMethod',
    value: function callComponentMethod(componentName, method) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      // Does the component exist?
      if (this.mainfest[componentName] && this.mainfest[componentName].instances) {
        this.mainfest[componentName].instances.forEach(function (instance) {
          // Use JS .apply to call the component method with proper context
          if ('function' === typeof instance[method]) {
            var _instance$method;

            (_instance$method = instance[method]).call.apply(_instance$method, [instance].concat(_toConsumableArray(args)));
          }
        });
      }
    }
  }]);

  return ComponentManager;
}();

exports.default = ComponentManager;


//////////////////
// WEBPACK FOOTER
// ./~/js-component-framework/lib/ComponentManager.js
// module id = ./node_modules/js-component-framework/lib/ComponentManager.js
// module chunks = 7